import { useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import schoolImage from "./WhatsApp Image 2026-04-12 at 19.59.14.jpeg";
import {
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  Timestamp,
  deleteDoc,
  doc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  runTransaction,
  collection,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB66uBawC8j2viYJ6c1UEMF0op-yicL42o",
  authDomain: "school-app-1145a.firebaseapp.com",
  projectId: "school-app-1145a",
  storageBucket: "school-app-1145a.firebasestorage.app",
  messagingSenderId: "127483826350",
  appId: "1:127483826350:web:acc4cb601e8294dcc2dd3f",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

const SLOTS = [
  "08:00-09:00",
  "09:00-10:00",
  "10:00-11:00",
  "11:00-12:00",
  "12:00-13:00",
  "13:00-14:00",
  "14:00-15:00",
  "15:00-16:00",
  "16:00-17:00",
  "17:00-18:00",
];

const ADMIN_EMAIL =
  process.env.REACT_APP_ADMIN_EMAIL || "admin@school-app-1145a.com";

function getLocalDateString(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const TODAY = getLocalDateString();

function getBookingId(date, slot) {
  return `${date}_${slot.replace(/:/g, "-")}`;
}

function initials(name) {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0])
    .join("");
}

export default function App() {
  const [page, setPage] = useState("book");
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: "", phone: "", date: TODAY, slot: "" });
  const [msg, setMsg] = useState(null);
  const [adminEmail, setAdminEmail] = useState(ADMIN_EMAIL);
  const [adminPass, setAdminPass] = useState("");
  const [adminMsg, setAdminMsg] = useState("");
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [filterDate, setFilterDate] = useState(TODAY);
  const [searchQ, setSearchQ] = useState("");
  const [viewDate, setViewDate] = useState(TODAY);

  useEffect(() => {
    const bookingsQuery = query(
      collection(db, "bookings"),
      orderBy("createdAt", "desc")
    );

    const unsubBookings = onSnapshot(
      bookingsQuery,
      (snap) => {
        setBookings(snap.docs.map((snapshotDoc) => ({ id: snapshotDoc.id, ...snapshotDoc.data() })));
        setLoading(false);
      },
      () => {
        setMsg({ t: "error", m: "تعذر تحميل الحجوزات. تأكد من إعدادات Firebase والصلاحيات." });
        setLoading(false);
      }
    );

    const unsubAuth = onAuthStateChanged(auth, (user) => {
      setAdminUser(user);
    });

    return () => {
      unsubBookings();
      unsubAuth();
    };
  }, []);

  const takenOn = (date) =>
    bookings.filter((booking) => booking.date === date).map((booking) => booking.slot);

  const handleSubmit = async () => {
    const { name, phone, date, slot } = form;

    if (!name.trim() || name.trim().split(/\s+/).length < 3) {
      setMsg({ t: "error", m: "يرجى إدخال الاسم الثلاثي كاملًا" });
      return;
    }

    if (!/^07\d{8}$/.test(phone)) {
      setMsg({ t: "error", m: "رقم الهاتف غير صحيح (مثال: 0791234567)" });
      return;
    }

    if (!slot) {
      setMsg({ t: "error", m: "يرجى اختيار موعد" });
      return;
    }

    const bookingId = getBookingId(date, slot);
    const bookingRef = doc(db, "bookings", bookingId);

    try {
      await runTransaction(db, async (transaction) => {
        const existingBooking = await transaction.get(bookingRef);

        if (existingBooking.exists()) {
          throw new Error("SLOT_TAKEN");
        }

        transaction.set(bookingRef, {
          name: name.trim(),
          phone,
          date,
          slot,
          createdAt: Timestamp.now(),
        });
      });

      setMsg({ t: "success", m: `تم الحجز بنجاح! ${name.trim()} - ${slot} - ${date}` });
      setForm({ name: "", phone: "", date: TODAY, slot: "" });
    } catch (error) {
      if (error.message === "SLOT_TAKEN") {
        setMsg({ t: "error", m: "هذا الموعد محجوز، يرجى اختيار موعد آخر" });
        return;
      }

      setMsg({ t: "error", m: "حدث خطأ أثناء الحجز. تأكد من اتصال الإنترنت وصلاحيات Firestore." });
    }
  };

  const handleAdminLogin = async () => {
    if (!adminEmail.trim() || !adminPass) {
      setAdminMsg("أدخل بريد المدير وكلمة المرور");
      return;
    }

    setAdminLoading(true);
    setAdminMsg("");

    try {
      await signInWithEmailAndPassword(auth, adminEmail.trim(), adminPass);
      setAdminPass("");
    } catch (error) {
      if (error.code === "auth/invalid-credential") {
        setAdminMsg("بيانات المدير غير صحيحة");
      } else {
        setAdminMsg("تعذر تسجيل الدخول. تأكد من تفعيل Email/Password في Firebase Auth.");
      }
    } finally {
      setAdminLoading(false);
    }
  };

  const handleAdminLogout = async () => {
    await signOut(auth);
    setAdminPass("");
    setAdminMsg("");
  };

  const handleCancel = async (id) => {
    if (!adminUser) {
      setAdminMsg("يجب تسجيل الدخول كمدير قبل إلغاء أي حجز");
      return;
    }

    if (!window.confirm("هل تريد إلغاء هذا الحجز؟")) return;

    try {
      await deleteDoc(doc(db, "bookings", id));
    } catch {
      setAdminMsg("فشل إلغاء الحجز. تأكد من صلاحيات Firestore للمدير.");
    }
  };

  const filtered = bookings.filter((booking) => {
    const matchesDate = !filterDate || booking.date === filterDate;
    const normalizedQuery = searchQ.trim().toLowerCase();

    return (
      matchesDate &&
      (!normalizedQuery ||
        booking.name.toLowerCase().includes(normalizedQuery) ||
        booking.phone.includes(normalizedQuery))
    );
  });

  const todayBookings = bookings.filter((booking) => booking.date === TODAY).length;
  const isAdmin = Boolean(adminUser);

  return (
    <div style={styles.app}>
      <div style={styles.container}>
      <div style={styles.header}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={styles.logoIcon}>
        <img src={schoolImage} alt="ملعب مدرسة أبو نصير الثانوية للبنين" style={styles.headerImage} />
          </div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 500 }}>ملعب مدرسة أبو نصير الثانوية للبنين</div>
            <div style={{ fontSize: 12, color: "#888" }}>نظام الحجز الإلكتروني</div>
          </div>
        </div>
        <div style={styles.tabs}>
          {[
            ["book", "احجز الآن"],
            ["slots", "المواعيد"],
            ["admin", "المدير"],
          ].map(([tabKey, label]) => (
            <button
              key={tabKey}
              style={{ ...styles.tab, ...(page === tabKey ? styles.tabActive : {}) }}
              onClick={() => {
                setPage(tabKey);
                setMsg(null);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {loading && <div style={styles.loading}>جاري التحميل...</div>}

      {!loading && page === "book" && (
        <>
          {msg && (
            <div style={{ ...styles.alert, ...(msg.t === "success" ? styles.alertSuccess : styles.alertError) }}>
              {msg.m}
            </div>
          )}

          <div style={styles.card}>
            <div style={styles.cardTitle}>بيانات الحاجز</div>
            <Field label="الاسم الثلاثي">
              <input
                style={styles.input}
                value={form.name}
                onChange={(event) => setForm({ ...form, name: event.target.value })}
                placeholder="مثال: أحمد محمد سعيد"
              />
            </Field>
            <div style={styles.twoColGrid}>
              <Field label="رقم الهاتف">
                <input
                  style={{ ...styles.input, direction: "ltr" }}
                  value={form.phone}
                  onChange={(event) => setForm({ ...form, phone: event.target.value })}
                  placeholder="07XXXXXXXX"
                />
              </Field>
              <Field label="التاريخ">
                <input
                  style={styles.input}
                  type="date"
                  value={form.date}
                  min={TODAY}
                  onChange={(event) => setForm({ ...form, date: event.target.value, slot: "" })}
                />
              </Field>
            </div>
          </div>

          <div style={styles.card}>
            <div style={styles.cardTitle}>اختر الموعد</div>
            <div style={styles.legend}>
              {[
                ["#97C459", "متاح"],
                ["#F09595", "محجوز"],
                ["#378ADD", "مختار"],
              ].map(([color, label]) => (
                <div key={label} style={styles.legendItem}>
                  <div style={{ width: 10, height: 10, borderRadius: "50%", background: color }} />
                  {label}
                </div>
              ))}
            </div>

            <div style={styles.slotGrid}>
              {SLOTS.map((slot) => {
                const taken = takenOn(form.date).includes(slot);
                const selected = form.slot === slot;

                return (
                  <button
                    key={slot}
                    type="button"
                    disabled={taken}
                    onClick={() => !taken && setForm({ ...form, slot })}
                    style={{
                      ...styles.slot,
                      ...(taken ? styles.slotTaken : selected ? styles.slotSelected : styles.slotFree),
                    }}
                  >
                    {slot}
                    <br />
                    <span style={styles.slotSubtext}>{taken ? "محجوز" : "متاح"}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <button style={styles.btnPrimary} onClick={handleSubmit}>
            تأكيد الحجز
          </button>
        </>
      )}

      {!loading && page === "slots" && (
        <div style={styles.card}>
          <div style={styles.cardTitle}>المواعيد المتاحة</div>
          <Field label="اختر تاريخ">
            <input
              style={styles.input}
              type="date"
              value={viewDate}
              min={TODAY}
              onChange={(event) => setViewDate(event.target.value)}
            />
          </Field>

          <div style={styles.twoColGrid}>
            <div style={{ ...styles.statBox, background: "#EAF3DE" }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: "#3B6D11" }}>
                {SLOTS.length - takenOn(viewDate).length}
              </div>
              <div style={{ fontSize: 12, color: "#639922", marginTop: 2 }}>موعد متاح</div>
            </div>
            <div style={{ ...styles.statBox, background: "#FCEBEB" }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: "#A32D2D" }}>
                {takenOn(viewDate).length}
              </div>
              <div style={{ fontSize: 12, color: "#993C1D", marginTop: 2 }}>موعد محجوز</div>
            </div>
          </div>

          <div style={styles.slotGrid}>
            {SLOTS.map((slot) => {
              const taken = takenOn(viewDate).includes(slot);

              return (
                <button
                  key={slot}
                  type="button"
                  disabled={taken}
                  onClick={() => {
                    if (!taken) {
                      setForm({ ...form, slot, date: viewDate });
                      setPage("book");
                    }
                  }}
                  style={{ ...styles.slot, ...(taken ? styles.slotTaken : styles.slotFree) }}
                >
                  {slot}
                  <br />
                  <span style={styles.slotSubtext}>{taken ? "محجوز" : "اضغط للحجز"}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}

      {!loading && page === "admin" && !isAdmin && (
        <div style={styles.adminWrap}>
          {adminMsg && <div style={{ ...styles.alert, ...styles.alertError }}>{adminMsg}</div>}
          <div style={styles.card}>
            <div style={styles.cardTitle}>دخول المدير</div>
            <Field label="بريد المدير">
              <input
                style={{ ...styles.input, direction: "ltr" }}
                type="email"
                value={adminEmail}
                onChange={(event) => setAdminEmail(event.target.value)}
                placeholder="admin@example.com"
              />
            </Field>
            <Field label="كلمة المرور">
              <input
                style={styles.input}
                type="password"
                value={adminPass}
                onChange={(event) => setAdminPass(event.target.value)}
                onKeyDown={(event) => event.key === "Enter" && handleAdminLogin()}
                placeholder="أدخل كلمة المرور"
              />
            </Field>
            <div style={styles.helperText}>
              استخدم حساب Firebase Auth الخاص بالمدير، ثم طبّق قواعد Firestore لحماية الحذف.
            </div>
            <button style={styles.btnPrimary} onClick={handleAdminLogin} disabled={adminLoading}>
              {adminLoading ? "جاري تسجيل الدخول..." : "دخول"}
            </button>
          </div>
        </div>
      )}

      {!loading && page === "admin" && isAdmin && (
        <>
          <div style={styles.adminHeader}>
            <div style={styles.adminUserCard}>
              <div style={{ fontSize: 12, color: "#666" }}>تم تسجيل الدخول كمدير</div>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{adminUser.email}</div>
            </div>
            <button
              style={{ ...styles.btn, fontSize: 12, padding: "8px 12px", color: "#A32D2D", borderColor: "#F09595" }}
              onClick={handleAdminLogout}
            >
              خروج
            </button>
          </div>

          <div style={styles.adminStatsGrid}>
            {[
              [bookings.length, "إجمالي الحجوزات"],
              [todayBookings, "حجوزات اليوم"],
              [SLOTS.length - todayBookings, "مواعيد شاغرة"],
            ].map(([count, label]) => (
              <div key={label} style={styles.statCard}>
                <div style={{ fontSize: 22, fontWeight: 500 }}>{count}</div>
                <div style={{ fontSize: 12, color: "#888", marginTop: 2 }}>{label}</div>
              </div>
            ))}
          </div>

          <div style={styles.card}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 14 }}>
              <div style={{ fontSize: 15, fontWeight: 500 }}>جميع الحجوزات</div>
            </div>

            {adminMsg && <div style={{ ...styles.alert, ...styles.alertError }}>{adminMsg}</div>}

            <div style={styles.adminFilterRow}>
              <input
                style={{ ...styles.input, ...styles.searchInput }}
                placeholder="بحث بالاسم أو الهاتف..."
                value={searchQ}
                onChange={(event) => setSearchQ(event.target.value)}
              />
              <input
                style={{ ...styles.input, ...styles.dateFilterInput }}
                type="date"
                value={filterDate}
                onChange={(event) => setFilterDate(event.target.value)}
              />
              <button
                style={{ ...styles.btn, ...styles.filterButton, padding: "8px 12px", fontSize: 12 }}
                onClick={() => {
                  setFilterDate("");
                  setSearchQ("");
                }}
              >
                الكل
              </button>
            </div>

            {filtered.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px 0", color: "#aaa", fontSize: 14 }}>
                لا توجد حجوزات مطابقة
              </div>
            ) : (
              filtered.map((booking) => (
                <div key={booking.id} style={styles.bookingRow}>
                  <div style={styles.avatar}>{initials(booking.name)}</div>
                  <div style={styles.bookingContent}>
                    <div style={styles.bookingName}>{booking.name}</div>
                    <div style={styles.bookingMeta}>
                      {booking.phone} - {booking.date} - {booking.slot}
                    </div>
                  </div>
                  <button
                    style={{
                      ...styles.btn,
                      background: "#FCEBEB",
                      color: "#A32D2D",
                      borderColor: "#F09595",
                      padding: "6px 12px",
                      fontSize: 12,
                    }}
                    onClick={() => handleCancel(booking.id)}
                  >
                    إلغاء
                  </button>
                </div>
              ))
            )}
          </div>
        </>
      )}
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 13 }}>
      <label style={{ display: "block", fontSize: 13, color: "#888", marginBottom: 5 }}>{label}</label>
      {children}
    </div>
  );
}

const styles = {
  app: {
    fontFamily: "system-ui, sans-serif",
    direction: "rtl",
    background: "#f5f5f5",
    minHeight: "100vh",
    padding: 16,
    boxSizing: "border-box",
  },
  container: {
    width: "100%",
    maxWidth: 1080,
    margin: "0 auto",
  },
  header: {
    background: "#fff",
    borderRadius: 12,
    border: "0.5px solid #e0e0e0",
    padding: "14px 18px",
    marginBottom: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 10,
    boxSizing: "border-box",
  },
  logoIcon: {
    width: 36,
    height: 36,
    background: "#E6F1FB",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  headerImage: {
    width: 45,
    maxWidth: 150,
    height: 45,
    objectFit: "cover",
    borderRadius: "50%",
    border: "0.5px solid #e0e0e0",
    display: "block",
    flex: "0 1 280px",
  },
  tabs: {
    display: "flex",
    gap: 5,
    background: "#f0f0f0",
    padding: 4,
    borderRadius: 8,
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "fit-content",
    boxSizing: "border-box",
  },
  tab: {
    padding: "7px 14px",
    border: "none",
    background: "transparent",
    borderRadius: 6,
    cursor: "pointer",
    fontSize: 13,
    color: "#666",
    fontFamily: "inherit",
    flex: "1 1 110px",
    minHeight: 38,
  },
  tabActive: { background: "#fff", color: "#111", fontWeight: 500, border: "0.5px solid #e0e0e0" },
  card: {
    background: "#fff",
    borderRadius: 12,
    border: "0.5px solid #e0e0e0",
    padding: 20,
    marginBottom: 14,
    boxSizing: "border-box",
    overflow: "hidden",
  },
  cardTitle: {
    fontSize: 15,
    fontWeight: 500,
    marginBottom: 16,
    paddingBottom: 12,
    borderBottom: "0.5px solid #eee",
  },
  input: {
    width: "100%",
    padding: "9px 12px",
    border: "0.5px solid #ccc",
    borderRadius: 8,
    background: "#fff",
    fontSize: 14,
    fontFamily: "inherit",
    outline: "none",
    boxSizing: "border-box",
    minWidth: 0,
  },
  twoColGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12,
    alignItems: "start",
  },
  legend: { display: "flex", gap: 14, marginBottom: 10, flexWrap: "wrap" },
  legendItem: { display: "flex", alignItems: "center", gap: 5, fontSize: 12, color: "#666" },
  slotGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
    gap: 8,
  },
  slot: {
    padding: "10px 6px",
    borderRadius: 8,
    border: "0.5px solid",
    cursor: "pointer",
    textAlign: "center",
    fontSize: 12,
    fontWeight: 500,
    lineHeight: 1.4,
    transition: "all .15s",
    fontFamily: "inherit",
    minHeight: 68,
    boxSizing: "border-box",
    width: "100%",
  },
  slotSubtext: { fontSize: 11, fontWeight: 400 },
  slotFree: { background: "#EAF3DE", color: "#3B6D11", borderColor: "#97C459" },
  slotTaken: {
    background: "#FCEBEB",
    color: "#A32D2D",
    borderColor: "#F09595",
    cursor: "not-allowed",
    opacity: 0.8,
  },
  slotSelected: { background: "#E6F1FB", color: "#0C447C", borderColor: "#378ADD" },
  btnPrimary: {
    width: "100%",
    padding: 12,
    border: "none",
    borderRadius: 8,
    background: "#185FA5",
    color: "#E6F1FB",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  btn: {
    padding: "9px 16px",
    border: "0.5px solid #ccc",
    borderRadius: 8,
    background: "#fff",
    fontSize: 14,
    cursor: "pointer",
    fontFamily: "inherit",
    boxSizing: "border-box",
  },
  alert: { padding: "12px 16px", borderRadius: 8, fontSize: 13, marginBottom: 14 },
  alertSuccess: { background: "#EAF3DE", color: "#3B6D11", border: "0.5px solid #97C459" },
  alertError: { background: "#FCEBEB", color: "#A32D2D", border: "0.5px solid #F09595" },
  statCard: { background: "#f8f8f8", borderRadius: 8, padding: 14, textAlign: "center" },
  statBox: { borderRadius: 8, padding: 12, textAlign: "center" },
  avatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    background: "#E6F1FB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13,
    fontWeight: 500,
    color: "#185FA5",
    flexShrink: 0,
  },
  loading: { textAlign: "center", padding: 40, color: "#888" },
  adminWrap: { maxWidth: 420, margin: "40px auto" },
  helperText: { fontSize: 12, color: "#777", marginBottom: 14, lineHeight: 1.6 },
  adminHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 14,
    flexWrap: "wrap",
  },
  adminUserCard: {
    background: "#fff",
    border: "0.5px solid #e0e0e0",
    borderRadius: 12,
    padding: "12px 16px",
  },
  adminStatsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: 10,
    marginBottom: 14,
  },
  adminFilterRow: {
    display: "flex",
    gap: 8,
    marginBottom: 14,
    flexWrap: "wrap",
    alignItems: "stretch",
  },
  searchInput: {
    flex: "1 1 240px",
  },
  dateFilterInput: {
    flex: "1 1 170px",
    maxWidth: 220,
  },
  filterButton: {
    flex: "1 1 90px",
    minHeight: 40,
  },
  bookingRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "12px 0",
    borderBottom: "0.5px solid #eee",
    flexWrap: "wrap",
  },
  bookingContent: { flex: "1 1 220px", minWidth: 0 },
  bookingName: {
    fontSize: 14,
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  bookingMeta: { fontSize: 12, color: "#888", marginTop: 2 },
};
